import { config } from '~app/config';

import { makeRequest } from '~shared/api/make-request';

import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { skipToken, useQuery } from '@tanstack/react-query';

import { partnerApplicationKeys } from './partner-application-keys';

import type { PartnerApplicationResponse } from '../model';

export async function getPartnerApplicationsByPerson(): Promise<
  PartnerApplicationResponse[]
> {
  const response = await makeRequest<
    ResponseSuccess<PartnerApplicationResponse[]>
  >({
    url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/find-by-person-id`,
    credentials: 'include',
    payload: {},
  });
  return response.payload;
}

export const usePartnerApplicationsByPerson = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  return useQuery({
    queryKey: partnerApplicationKeys.byPerson(),
    queryFn: enabled ? getPartnerApplicationsByPerson : skipToken,
  });
};

export const useFirstPartnerApplicationsByPerson = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  return useQuery({
    queryKey: partnerApplicationKeys.byPerson(),
    queryFn: enabled ? getPartnerApplicationsByPerson : skipToken,
    select: (data) => {
      return data.filter(({ status }) => status !== 'REJECTED')[0];
    },
  });
};
